/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTextTitle from 'base/components/standalone/TextTitle';

export const DynamicStandaloneTextTitle = StandaloneTextTitle;
export type DynamicStandaloneTextTitleProps = PropsFromComponent<typeof StandaloneTextTitle>;

export const DynamicStandaloneTextTitleWith = (extras: DynamicStandaloneExtras): typeof StandaloneTextTitle => {
    return function DynamicStandaloneTextTitle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TextTitle');
        return <StandaloneTextTitle {...mergeProps({ options: { theme } }, props)} />;
    }
}